import React from 'react';
import Step from './Step';
import UnitTypeCalculationPropertiesRow, {
    UnitTypeHeatingCalculationPropertiesRow,
    UnitTypeDHWCalculationPropertiesRow
} from './UnitTypeCalculationPropertiesRow';
import Field from '../../../model/configurator/Field';
import StepModel from '../../../model/configurator/StepModel';
import SystemSetupField from '../../../model/configurator/unit-type/SystemSetupField';
import HeatingCheckboxesField from '../../../model/configurator/unit-type/HeatingCheckboxesField';
import CalculationPropertiesRowField from '../../../model/configurator/unit-type/CalculationPropertiesRowField';
import CrossReferencedDHWField from '../../../model/configurator/unit-type/CrossReferencedDHWField';
import CrossReferencedHeatingField from '../../../model/configurator/controller/CrossReferencedHeatingField';
import {
    CalculationPropertiesRowDHWPressureField,
    CalculationPropertiesRowPressureField,
    CalculationPropertiesRowHeatingPressureField
} from '../../../model/configurator/unit-type/CalculationPropertiesRowPressureField';
import Apartment from "@lib/components/configuration/steps/tws/Apartment";
import NeedsCalculationGraph from "@lib/components/configuration/steps/tws/NeedsCalculation/NeedsCalculationGraph";
import NeedsCalculationRow from "@lib/components/configuration/steps/tws/NeedsCalculation/NeedsCalculationRow";
import ExpandableContainer from "@lib/components/configuration/steps/ExpandableContainer";
import store from '../../../store/configuration';

const StepUnitTypeSection = props => {
    return (
        <div className={`column-3 column-xs-${props.mobileColumnSize} configuration-editor-section`}>
            <div className="configuration-editor-section-label">{__(props.title)}</div>
            <div className="configuration-editor-section-body">
                {props.children}
            </div>
        </div>
    )
}

export default class StepUnitType extends Step {

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.model.__version !== this.props.model.__version
    }

    renderBody(model) {
        if (model.unitType === null) {
            return (<React.Fragment></React.Fragment>)
        }

        const hasDesign = typeof model.unitType.design !== 'undefined'
        const hasDHWDesign = typeof model.dhw !== 'undefined' && model.dhw && typeof model.dhw.design !== 'undefined'
        const isMoreThen1Heating = model.heating2 !== undefined || hasDHWDesign;
        const isCustom = this.props.model.unitType.isCustomLogic.value;
        const twsEnabled = true;

        let matchingUnits = this.props.model.unitType.needsCalculation.matchingUnits;

        let needsCalculation = this.props.model.unitType.needsCalculation;
        return (
            <React.Fragment>
                <div className="row row-no-outer-gutter">
                    <StepUnitTypeSection title="Product" mobileColumnSize={12}>
                        {this.renderFieldv2(this.fields.productType)}
                        <div className="product-checkbox">
                            {this.renderFieldv2(this.fields.isFloorstanding)}
                        </div>
                    </StepUnitTypeSection>

                    {(!isCustom && this.fields.systemSetup.visible) &&
                        <StepUnitTypeSection title="HE System Setup" mobileColumnSize={6}>
                            {this.renderFieldv2(this.fields.systemSetup)}
                        </StepUnitTypeSection>}

                    {!isCustom && model.unitType.heatingSectionCount.visible && model.unitType.heatingSectionCount.items.length > 0 ? (
                        <StepUnitTypeSection title="Heating Configuration" mobileColumnSize={6}>
                            <div className="row row-no-gutter configuration-unittype-heating-section">
                                <div className="column-5">
                                    {this.renderFieldv2(this.fields.heatingSectionCount)}
                                </div>
                            </div>
                        </StepUnitTypeSection>
                    ) : ''}

                    {false && <StepUnitTypeSection title="Options">
                        <div className="configuration-options-checkbox">
                            {this.renderFieldv2(this.fields.energyMeter)}
                        </div>
                    </StepUnitTypeSection>}
                </div>


                {
                    twsEnabled && model.unitType.needsCalculation.visible && <React.Fragment>
                        <ExpandableContainer label={__('Needs calculation')}>
                            <div className="configuration-editor-section">
                                <div className="configuration-editor-section-body">
                                    <div className="row row-no-gutter">

                                        <div className="column-6">
                                            <div className="heating-horizontal-field">
                                                <div
                                                    className="heating-horizontal-field-label">{this.fields.application.label}</div>
                                                <div className="heating-horizontal-field-input">
                                                <span
                                                    className="input">{this.renderFieldv2(this.fields.application)}</span>
                                                    <span className="unit"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="needs-calculation-section-header">{__('General settings')}</div>

                                    <Apartment renderFieldv2={this.renderFieldv2} step={this.stepModel}></Apartment>

                                    {matchingUnits.itemsViewModel && matchingUnits.itemsViewModel.length > 0 &&
                                        <div>
                                            <div
                                                className="needs-calculation-section-header">{__('Proposed configurations')}</div>
                                            <table className="needs-calculation-table">
                                                <thead>
                                                <tr>
                                                    <th>{__('Power')} [kW]</th>
                                                    <th>{__('Storage')} [l]</th>
                                                    <th>{__('Operating mode')}</th>
                                                    <th>{__('Load time')}</th>
                                                    <th></th>
                                                    {/*<th>Load time with recycling flow rate</th>*/}
                                                    {/*<th>Load time without recycling flow rate</th>*/}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    matchingUnits.itemsViewModel.map(matchingUnit => {
                                                            return <NeedsCalculationRow model={matchingUnit}
                                                                                        selectedId={store.formModel.unitType.proposedConfigurationId}
                                                                                        onClick={this.onProposedConfigurationClick}/>
                                                        }
                                                    )
                                                }
                                                <NeedsCalculationRow
                                                    selectedId={store.formModel.unitType.proposedConfigurationId}
                                                    onClick={this.onProposedConfigurationClick}
                                                    model={this.props.model.unitType.needsCalculation.fullAccumulation}/>
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                    {needsCalculation.primaryTankUnitCapacity.value &&
                                        <div>
                                            <div className="needs-calculation-section-header">{__('Primary tank')}</div>

                                            <div className="heating-horizontal-field">

                                                <div className="heating-horizontal-field-label">
                                                    {needsCalculation.primaryTankUnitCapacity.label} {needsCalculation.primaryTankUnitCapacity.value} {needsCalculation.primaryTankUnitCapacity.unit}
                                                </div>
                                            </div>
                                            <div className="heating-horizontal-field">
                                                <div className="heating-horizontal-field-label">
                                                    {needsCalculation.primaryTankPrimaryStorage.label} {needsCalculation.primaryTankPrimaryStorage.value} {needsCalculation.primaryTankPrimaryStorage.unit}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        this.fields.diagram.value.svgDiagram &&
                                        <div>
                                            <div className="needs-calculation-section-header">{__('Needs curve')}</div>

                                            <NeedsCalculationGraph
                                                code={this.fields.diagram.value.svgDiagram}
                                                metaData={this.fields.diagram.value.metaData}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </ExpandableContainer>
                    </React.Fragment>
                }

                <div className="configuration-editor-unittype-divider"></div>
                {
                    !isCustom && <StepUnitTypeSection title="Calculation properties">
                        <div className="row row-no-gutter">
                            <div className="column-8 column-xs-12">
                                <table className="configuration-editor-unittype-table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>{__('Temperature')}</th>
                                        <th>{__('Pressure')}</th>
                                        <th>{__('PN')}</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {hasDesign ? <UnitTypeCalculationPropertiesRow row={this.fields.design} step={this}/> :
                                        <React.Fragment></React.Fragment>}
                                    {this.renderHeatingCalculationPropertiesRowFields(model)}
                                    {hasDHWDesign ? <UnitTypeDHWCalculationPropertiesRow text={model.dhw.name.value}
                                                                                         row={this.fields.dhwDesign}
                                                                                         step={this}
                                                                                         allowEdit={!model.dhw.name.disabled}/> :
                                        <React.Fragment></React.Fragment>}
                                    </tbody>
                                </table>
                            </div>

                            <div className="column-4 column-xs-12">
                                <div className="configuration-editor-differential-pressure">
                                    <div
                                        className="configuration-editor-differential-pressure-label">{__('Differential Pressure')}</div>
                                    <div>
                                        <div className="row flex-center-v">
                                            <div className="column-2 label">{__('Min.')}</div>
                                            <div className="column-10 input flex-center-v">
                                                <span>{this.renderFieldv2(this.fields.minDifferentialPressure)}</span>
                                                <span className="text-muted" style={{
                                                    paddingLeft: '4px'
                                                }}>{this.fields.minDifferentialPressure.unit}</span>
                                            </div>
                                        </div>

                                        <div className="row flex-center-v">
                                            <div className="column-2 label">{__('Max.')}</div>
                                            <div className="column-10 input flex-center-v">
                                                <span>{this.renderFieldv2(this.fields.maxDifferentialPressure)}</span>
                                                <span className="text-muted" style={{
                                                    paddingLeft: '4px'
                                                }}>{this.fields.maxDifferentialPressure.unit}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StepUnitTypeSection>
                }
            </React.Fragment>
        )
    }

    onProposedConfigurationClick = id => {
        this.fields.proposedConfigurationId.value = id;
        store.recentlyChangedField = this.fields.proposedConfigurationId.getModelPath()
        this.props.onFormModelChange();
    }

    renderHeatingCalculationPropertiesRowFields(model) {
        const hasHeating1 = (typeof model.heating1 !== 'undefined')
        const hasHeating2 = (typeof model.heating2 !== 'undefined')
        const hasHeating3 = (typeof model.heating3 !== 'undefined')

        return (
            <React.Fragment>
                {hasHeating1 ? <UnitTypeHeatingCalculationPropertiesRow text={model.heating1.name.value}
                                                                        warning={model.heating1.name.warning}
                                                                        row={this.fields.heating1Design} step={this}
                                                                        allowEdit={!model.heating1.name.disabled}
                                                                        editHeatingIdx={1}/> :
                    <React.Fragment></React.Fragment>}
                {hasHeating2 ? <UnitTypeHeatingCalculationPropertiesRow text={model.heating2.name.value}
                                                                        warning={model.heating2.name.warning}
                                                                        row={this.fields.heating2Design} step={this}
                                                                        allowEdit={!model.heating2.name.disabled}
                                                                        editHeatingIdx={2}/> :
                    <React.Fragment></React.Fragment>}
                {hasHeating3 ? <UnitTypeHeatingCalculationPropertiesRow text={model.heating3.name.value}
                                                                        warning={model.heating3.name.warning}
                                                                        row={this.fields.heating3Design} step={this}
                                                                        allowEdit={!model.heating3.name.disabled}
                                                                        editHeatingIdx={3}/> :
                    <React.Fragment></React.Fragment>}
            </React.Fragment>
        )
    }

    static getFields(step) {

        const createField = name => new Field(name, step)
        const createHeatingCPR = index => new CalculationPropertiesRowField('heating' + index + '.design', step, {
            temperature: new CrossReferencedHeatingField('design.temperature', step, index),
            pressure: new CalculationPropertiesRowHeatingPressureField('design.pressure', step, index),
            pn: new CrossReferencedHeatingField('design.pn', step, index)
        })

        return {
            productType: createField('productType'),
            isFloorstanding: createField('isFloorstanding'),
            aquaEfficiency: createField('aquaEfficiency'),
            application: createField('needsCalculation.application'),
            systemSetup: new SystemSetupField('systemSetup', step),
            heatingSectionCount: new HeatingCheckboxesField('heatingSectionCount', step),
            energyMeter: createField('energyMeter'),
            minDifferentialPressure: createField('minDifferentialPressure'),
            maxDifferentialPressure: createField('maxDifferentialPressure'),

            design: new CalculationPropertiesRowField('design', step, {
                text: __('Primary side'),
                temperature: createField('design.temperature'),
                pressure: new CalculationPropertiesRowPressureField('design.pressure', step),
                pn: createField('design.pn')
            }),

            dhwDesign: new CalculationPropertiesRowField('dhw.design', step, {
                temperature: new CrossReferencedDHWField('design.temperature', step),
                pressure: new CalculationPropertiesRowDHWPressureField('design.pressure', step),
                pn: new CrossReferencedDHWField('design.pn', step)
            }),

            heating1Design: createHeatingCPR(1),
            heating2Design: createHeatingCPR(2),
            heating3Design: createHeatingCPR(3),
            proposedConfigurationId: createField('proposedConfigurationId'),
            diagram: createField('needsCalculation.needsCurve')
        }
    }

    static getFirstVisibleField(fields) {
        return () => {
            return fields.productType;
        };
    }

    static getLastVisibleField(fields) {
        return () => {
            return fields.maxDifferentialPressure;
        };
    }

    static getStepModel(model) {
        return new StepModel('unitType', model.unitType)
    }
}
